import SwitcherContainer from "../../../../../src/entities/UI/SwitcherContainer";
import { eventBus, EnumEventBus } from "../managers/EventBus";


export default class SupplModeSwitcherCon extends SwitcherContainer {
  constructor() {
    super({ 
      header: "Supplementary Visual",
      coords: {
        vertical: { x: -200, y: 560 },
        horizontal: { x: 160, y: 300 }
      },
      handleFunc:(v: boolean) => eventBus.emit(EnumEventBus.supplementaryMode, v)
    });
  }
}